module.exports = __webpack_public_path__ + "img/BI.b36c9648.png";